import styled from 'styled-components'

export const TitleRow = styled.div`
	display: flex;
	align-items: center;
	column-gap: 6px;
	margin-bottom: 12px;

	> svg {
		stroke-width: 1.5;
	}
`
